module.exports = __webpack_public_path__ + "img/654798c6dbf6410e9c1552a5f1078ad2.4914b816.jpg";